import {useState} from 'react';
import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";

import CustomSelect from '../common/CustomSelect';
import CustomTextField from '../common/CustomTextField';
import TitleDivider from "./TitleDivider";
import './ReferralSourceForm.scss';
import {getReferralSourceCategories} from '../../helpers/selectOptions';

const referralOptions = getReferralSourceCategories();

const ReferralSourceForm = props => {
  const {onSubmit} = props;
  const [source, setSource] = useState(null);
  const [sourceDetails, setSourceDetails] = useState(null);
  const [note, setNote] = useState(null);
  const sourceType = referralOptions.find(r => r.value === source);

  return (
    <Stack
      className="ReferralSourceForm"
    >
      {/* <TitleDivider text='Final Information'/> */}

      {/* <Typography variant='large500Tight'>This helps us give you the best possible care.</Typography> */}

      <Stack gap='10px' width='100%' paddingTop={1}>
        <CustomSelect
          id='source-input'
          label='How did you hear about us?'
          placeholder='Select an option'
          required
          options={referralOptions.filter(opt => opt?.disabled !== true)}
          onChange={e => setSource(e.target.value)}
          className="ReferralSourceForm__select"
        />
        {
          source
            ? <CustomTextField
              id='source-details'
              label='Please specify further'
              placeholder={sourceType.followup}
              required
              onChange={e => setSourceDetails(e.target.value)}
              className="ReferralSourceForm__text-field"
            />
            : <></>
        }

        <CustomTextField
          id='note-input'
          label='Note to provider'
          placeholder='Why are you seeking care? What are your goals? Any limited availability?'
          required
          multiline
          rows={3.6}
          onChange={e => setNote(e.target.value)}
          className="ReferralSourceForm__note"
        />
      </Stack>
      <Button
        sx={{alignSelf: 'center', marginTop: '9px !important'}}
        variant='primaryGradient'
        size='medium'
        fullWidth={false}
        disabled={!source || !sourceDetails}
        onClick={() =>
          onSubmit({
            patientReferral: source,
            patientReferralDetails: sourceDetails,
            optionalNote: note
          })
        }
      >
        Submit
      </Button>
    </Stack>
  );
};

export default ReferralSourceForm;
